<template>
  <TableGradient
      icon-name="angle-double-right"
      title="Triggers"
      :text-empty="$t('trigger.listagem.table.empty')"
      route-new="trigger.create"
      :text-new="$t('trigger.listagem.table.novo')"
      :fields="fields"
      :fields-filter="filter"
      :items="triggers"
      :loading="isLoading"
      :paginator="pagination"
      @list="evt => $store.dispatch('trigger/listAll', evt)"
      table-data>
    <template v-slot:cell(id)="linha">
      <router-link :id="'link-edit-' + linha.index" :to="{ name: 'trigger.edit', params: { id: linha.item.id }}"
                   class="font-weight-bold">
        {{ $t('trigger.listagem.table.editar') }}
      </router-link>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import TableData from "@/components/TableData";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Index",
  components: {TableData, TableGradient},
  computed: {
    ...mapGetters({
      triggers: 'trigger/all',
      store_isLoading: 'trigger/isLoading',
      pagination: 'trigger/pagination'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'user_id', thClass: 'd-none', tdClass: 'd-none'},
        {key: 'name', label: this.$t('trigger.listagem.table.nome'), sortable: true},
        {key: 'rule', label: this.$t('trigger.listagem.table.regra'), sortable: true},
        {key: 'vam_triggers_actions_d', thClass: 'd-none', tdClass: 'd-none'},
        {key: 'status', thClass: 'd-none', tdClass: 'd-none'},
        {key: 'created_at', thClass: 'd-none', tdClass: 'd-none'},
        {key: 'updated_at', thClass: 'd-none', tdClass: 'd-none'},
        {key: 'id', label: this.$t('trigger.listagem.table.acoes')},
      ],
      filter: [
        {key: 'name', label: this.$t('trigger.listagem.table.nome')},
        {key: 'rule', label: this.$t('trigger.listagem.table.regra')},
      ],
    }
  },
  methods: {
    ...mapActions([
      'trigger/listAll'
    ])
  },
  mounted() {
    this['trigger/listAll']()
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
